import React from 'react';
const htmlFamilyTermsOfUse = require('./htmlFamilyTermsOfUse.html');

export default function ProviderTermsOfUse() {
    return <div dangerouslySetInnerHTML={{ __html: htmlFamilyTermsOfUse.default }} style={{ padding: 60 }} />;
}
